import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	DeleteCustomFieldDropdownOptionInput,
	DeleteCustomFieldDropdownOptionMutation,
	DeleteCustomFieldDropdownOptionMutation$rawResponse,
} from './__generated__/DeleteCustomFieldDropdownOptionMutation.graphql';
import type {Disposable} from 'relay-runtime';

const mutation = graphql`
	mutation DeleteCustomFieldDropdownOptionMutation($input: DeleteCustomFieldDropdownOptionInput!) @raw_response_type {
		deleteCustomFieldDropdownOption(input: $input) {
			deletedOptionId
			replacementOptionId
		}
	}
`;

function getOptimisticResponse(
	input: DeleteCustomFieldDropdownOptionInput
): DeleteCustomFieldDropdownOptionMutation$rawResponse {
	return {
		deleteCustomFieldDropdownOption: {
			deletedOptionId: input.optionId,
			replacementOptionId: input.replacementOptionId,
		},
	} as DeleteCustomFieldDropdownOptionMutation$rawResponse;
}

function commit(
	environment: Environment,
	input: MutationInput<DeleteCustomFieldDropdownOptionInput>,
	onSuccess: RelayOnCompleted<DeleteCustomFieldDropdownOptionMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinitionDropdownOption - Deleted');

	return trackAndCommitMutation<DeleteCustomFieldDropdownOptionMutation>(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
		optimisticResponse: getOptimisticResponse(input),
	});
}

export default {commit};
